"use client";

import { useEffect } from "react";
import { captureException } from "@client/observability/capture";
import { Button } from "@/client/components/ui/button";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[Error Boundary]", error);
    captureException(error, { runtime: "web", component: "AppErrorBoundary" });
  }, [error]);

  return (
    <div className="min-h-screen bg-warm-50 flex items-center justify-center p-6">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-6">
          <svg
            className="w-10 h-10 text-red-400"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
            />
          </svg>
        </div>
        <h1 className="mb-3 font-serif text-3xl text-warm-950">
          Something went wrong
        </h1>
        <p className="text-warm-700 mb-8">
          An unexpected error occurred. Please try again.
        </p>
        <Button type="button" size="xl" onClick={reset}>
          Try again
        </Button>
      </div>
    </div>
  );
}
